import React, { Fragment, useEffect, useState, useMemo } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, OverlayTrigger, Popover, Badge, Tooltip, Accordion } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link, useLocation, useNavigate } from 'react-router-dom'
// img

import avatars11 from '../../../assets/images/avatars/01.png'
import avatars22 from '../../../assets/images/avatars/avtar_1.png'
import avatars33 from '../../../assets/images/avatars/avtar_2.png'
import avatars44 from '../../../assets/images/avatars/avtar_3.png'
import avatars55 from '../../../assets/images/avatars/avtar_4.png'
import avatars66 from '../../../assets/images/avatars/avtar_5.png'
import avatars2 from '../../../assets/images/avatars/02.png'
import avatars3 from '../../../assets/images/avatars/03.png'
import avatars4 from '../../../assets/images/avatars/04.png'
import avatars5 from '../../../assets/images/avatars/05.png'
import StartMarker from "../../../assets/images/icons/start-marker.svg"
import TripStartFlag from "../../../assets/images/trip-start-flag.png"
import TripEndFlag from "../../../assets/images/trip-end-flag.png"

import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import { userSignal } from '../../../signal/userSignal';
import * as moment from 'moment';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import CountUp from "react-countup";
import { Swiper, SwiperSlide } from 'swiper/react';
import Circularprogressbar from '../../../components/circularprogressbar';
import SwiperCore, { Navigation } from "swiper";
import DataTable from 'react-data-table-component';
import Zoom from 'react-medium-image-zoom'
import avatar1 from "../../../assets/images/avatars/01.png"
import checkMark from "../../../assets/images/check-mark.png"
import { GoogleMap, Marker, useLoadScript, Polyline, useJsApiLoader, InfoWindow } from "@react-google-maps/api";
import ExpenseViewModal from '../expenses/ExpenseViewModal';
import { allUsersSignal } from '../../../signal/allUsersSignal';
import EditTaskModal from './EditTaskModal';
import { dealerSignal } from '../../../signal/dealerSignal';
import EditTripModal from './EditTripModal';
import CustomToggle from '../../../components/dropdowns';
import { confirmAlert } from 'react-confirm-alert';
import { organisationSignal } from '../../../signal/organisationSignal';
import Avatar from 'react-avatar';
import { decode } from "@googlemaps/polyline-codec";
import { googleMapKey } from '../../../constants/googleMapKey';
import TripTimeline from './TripTimeline';

// install Swiper modules
SwiperCore.use([Navigation]);

const TripDetails = () => {
  const url = useLocation();
  const navigate = useNavigate();
  
  // Add better ID extraction with validation
  const id = useMemo(() => {
    try {
      const pathSegments = url.pathname.split("/");
      const tripId = pathSegments[3];
      
      if (!tripId) {
        throw new Error("Invalid trip ID in URL");
      }
      
      return tripId;
    } catch (err) {
      console.error("Failed to extract trip ID:", err);
      navigate("/dashboard/trips");
      return null;
    }
  }, [url.pathname]);

    const [toggler, setToggler] = useState();
    const [trip, setTrip] = useState({});
    const [tripMetaData, setTripMetaData] = useState({});
    const [user, setUser] = useState({});
    const [expenses, setExpenses] = useState([]);
    const [orders, setOrders] = useState([]);
    const [text, setText] = useState({});
    const [showExpenseViewModal, setShowExpenseViewModal] = useState(false);
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [showEditTaskModal, setShowEditTaskModal] = useState(false);
    const [showEditTripModal, setShowEditTripModal] = useState(false);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapKey,
    });

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const tripDetails = useQuery(
        ["tripDetails", id], // Add id to query key
        async () => {
            // Validate id before making request
            if (!id) {
                throw new Error("Trip ID is missing");
            }

            const response = await axios.get(`${DEV_SERVER}/trip/v2/${id}`, {
                headers: {
                    Authorization: `Bearer ${userSignal.value?.token}`,
                }
            });

            return response.data;
        },
        {
            enabled: !!id, // Only run query when id exists
            retry: 1,
            onSuccess: (data) => {
                if (data.status) {
                    setTrip(data.data);
                    userDetails.mutate(data.data.userId);
                    expensesDetails.mutate(data.data._id);
                    ordersDetails.mutate({
                        date: data.data.date,
                        userId: data.data.userId
                    });
                    getTripMetaData.refetch();
                } else {
                    toast.error(data.message);
                    navigate("/dashboard/trips");
                }
            },
            onError: (error) => {
                console.error("Trip details error:", error);
                toast.error(error.message || "Failed to fetch trip details");
                navigate("/dashboard/trips");
            }
        }
    );

    const userDetails = useMutation(async (data) => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/employee/${data}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                setUser(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const expensesDetails = useMutation(async (data) => {
        // Add validation
        if (!data) {
            throw new Error('Trip ID is required');
        }

        let resp = await axios.get(`${DEV_SERVER}/expense/v2?tripId=${data}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                setExpenses(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const ordersDetails = useMutation(async (data) => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2?startTime=${data?.date}&endTime=${data?.date + 8640000000}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                setOrders(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const updateExpenseStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/expense/v2/updateStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (response) => {
            // Access the response.data from axios
            const data = response.data;
            if (data.status) {
                toast.success(data.message);
                // Refetch expenses after successful update
                if (trip?._id) {
                    expensesDetails.mutate(trip._id);
                }
            } else {
                toast.error(data.message);
            }
        },
        onError: (error) => {
            console.error('Update expense error:', error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const getTripMetaData = useQuery("tripMetaData", async () => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/getTripMetadata/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        retry: 0,
        onSuccess: (data) => {
            if (data.status) {
                setTripMetaData(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
        }
    })

    let updateExpenseStatus = (id, status, reason) => {
        if (!id) {
            toast.error("Expense ID is required");
            return;
        }

        updateExpenseStatusMutation.mutate({
            id,
            body: {
                status,
                reason: reason || ''
            }
        });
    }

    let MarkTripInvalid = useMutation((data) => axios.post(`${DEV_SERVER}/trip/v2/markTripInvalid`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        }
    }), {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                tripDetails.refetch({ cancelRefetch: true });
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let handleMarkTripInvalid = () => {

        confirmAlert({
            title: 'Confirm to Mark Invalid',
            message: 'Are you sure you want to mark this trip Invalid?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => MarkTripInvalid.mutate({ body: { tripId: trip?.id } }),
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        })


    }

    useEffect(() => {
        tripDetails.refetch({ cancelRefetch: true });

    }, [])

    const taskColumns = [
        {
            name: "Title",
            selector: "title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.title}</Tooltip>}>
                    <span>{row?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "description",
            center: true,
            cell: (row) => {
                return row?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}>
                    <span>{row?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.status === "pending" ? <Badge bg="warning">{row?.status}</Badge> : <Badge bg="success">{row?.status}</Badge>
            },
            center: true,
        },
        {
            name: "Dealer",
            selector: "dealerId",
            cell: (row) => {
                if (dealerSignal?.value && dealerSignal?.value[row?.dealerId]) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{dealerSignal.value[row?.dealerId]?.name}</Tooltip>}>
                        <span>{dealerSignal.value[row?.dealerId]?.name}</span>
                    </OverlayTrigger>
                }
                return "-"
            },
            center: true
        },
        {
            name: "Remarks",
            selector: "remarks",
            center: true,
            cell: (row) => {
                return row?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remarks}</Tooltip>}>
                    <span>{row?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Remark image",
            center: true,
            cell: (row) => (
                <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    {row?.media && row?.media.length > 0 && row?.media.map((url, index) => (
                        <Zoom key={index}>
                            <img
                                src={url}
                                alt={`Remark ${index + 1}`}
                                onLoad={(e) => { e.target.style.pointerEvents = "unset" }}
                                onError={(e) => {
                                    e.target.style.pointerEvents = "none";
                                    e.target.src = "fallback-image-url";
                                }}
                                style={{
                                    pointerEvents: "none",
                                    cursor: "pointer",
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "10px",
                                    objectFit: "cover"
                                }}
                            />
                        </Zoom>
                    ))}
                </div>
            ),
            width: "150px"
        },
        {
            name: "Completed Time",
            selector: (row) => {

                if (row?.completedAt === "" || row?.completedAt === null || row?.completedAt === undefined || row?.completedAt === 0) {
                    return "-"
                }
                return moment(row?.completedAt).format("hh:mm A")
            },
            center: true,
        },
        {
            name: "Address",
            selector: (row) => {
                const address = [row?.destinationArea, row?.destinationCity, row?.destinationState]
                    .filter(Boolean)
                    .join(", ");
                return (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip style={{ position: "fixed" }}>{address || "NA"}</Tooltip>}
                    >
                        <span>{address || "NA"}</span>
                    </OverlayTrigger>
                );
            },
            width: "300px",
            center: true,
        },
        {
            name: "Completed Location",
            selector: (row) => {
                if (row?.completedAtLocation?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.completedAtLocation[0]},${row?.completedAtLocation[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            },
            center: true,
        }
    ]

    const expenseColumns = [
        {
            name: "Title",
            color: true,
            center: true,
            selector: "title",
        },
        {
            name: "Description",
            color: true,
            center: true,
            selector: "description",
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "User",
            color: true,
            center: true,
            selector: (row) => {
                if (user?.profileURL) {
                    return <span style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                        <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={user?.profileURL !== "" ? user?.profileURL : avatar1} />
                        {user?.name}
                    </span>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "red" : (row?.status === "approved" ? "green" : "orange") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return row?.reviewedBy[0].name
                }
                return "NA"
            }
        },
        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.reason === "" ? "NA" : row?.reason
                }
            }
        },
        {
            name: "Action",
            color: true,
            center: true,
            selector: (row) => <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateExpenseStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
            </span>
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        }
    ]

    const ordersColumns = [
        {
            name: "Date",
            center: true,
            selector: "createdAt",
            cell: (row) => `${moment(row?.createdAt).format("DD/MM/YY")}`,
            sortable: true,
        },
        {
            name: "Dealer",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            {(dealerSignal.value[row?.dealerId]?.visitingCard?.length && dealerSignal.value[row?.dealerId]?.visitingCard?.length !== 0) ?
                                <img
                                    style={{ width: "20px", height: "20px" }}
                                    src={(dealerSignal.value[row?.dealerId]?.visitingCard?.length && dealerSignal.value[row?.dealerId]?.visitingCard?.length !== 0) ? dealerSignal.value[row?.dealerId]?.visitingCard[0]?.url : ""}
                                    className="rounded-circle avatar-xs"
                                    alt="friend"
                                />

                                : <>
                                    <Avatar name={dealerSignal.value[row?.dealerId]?.name} size="20" round style={{ borderRadius: "50% !important", width: "20px !important", height: "20px !important", overflow: 'unset' }} />
                                </>}
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {dealerSignal.value[row?.dealerId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{dealerSignal.value[row?.dealerId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Stage",
            center: true,
            selector: (row) => {
                return <Badge onClick={() => navigate(`/dashboard/orders/${row?.id}`)} bg={organisationSignal?.value?.orderStageColors[row?.currentOrderStage]} text="white">{row?.currentOrderStage}</Badge>
            }
        },
        {
            name: "Subtotal",
            center: true,
            selector: "subTotal",
            cell: (row) => row?.subTotal > 10000 ? `${parseFloat(row?.subTotal / 1000).toFixed(2)}K Rs` : `${parseFloat(row?.subTotal).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Total Amount",
            center: true,
            selector: "totalAmount",
            cell: (row) => row?.totalAmount > 10000 ? `${parseFloat(row?.totalAmount / 1000).toFixed(2)}K Rs` : `${parseFloat(row?.totalAmount).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Total Items",
            center: true,
            selector: "totalItems",
            sortable: true
        },
        {
            name: "Created By",
            center: true,
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            <img
                                style={{ width: "20px", height: "20px" }}
                                src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                className="rounded-circle avatar-xs"
                                alt="friend"
                            />
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Employee Commission",
            center: true,
            selector: "userCommissionInPercentage",
            cell: (row) => `${parseFloat(row?.userCommissionInPercentage).toFixed(2)} %`,
        }
    ]

    const farmerColumns = [
        {
            name: "Name",
            center: true,
            selector: (row) => row?.name || "-",
            sortable: true
        },
        {
            name: "Phone Number",
            center: true,
            selector: "phoneNumber",
        },
        {
            name: "Location",
            center: true,
            selector: (row) => `${row?.city ? row?.city + ", " : ""}${row?.state || ""}`,
        },
        {
            name: "Group",
            center: true,
            selector: "group",
        },
        {
            name: "Updated At",
            center: true,
            selector: "updatedAt",
            cell: (row) => moment(row?.updatedAt).format("DD/MM/YY hh:mm A"),
            sortable: true
        },
        {
            name: "Action",
            center: true,
            cell: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip style={{ position: "fixed" }}>View Details</Tooltip>}
                >
                    <span
                        style={{ cursor: "pointer", color: "#0d6efd" }}
                        onClick={() => navigate(`/dashboard/farmers/${row?.id || row?._id}`)}
                    >
                        <i className="far fa-eye table-icons"></i>
                    </span>
                </OverlayTrigger>
            )
        }
    ];

    const suggestionColumns = [
        {
            name: "Farmer",
            center: true,
            selector: (row) => row?.farmer?.name || "—",
        },
        {
            name: "Stage",
            center: true,
            selector: (row) => {
                const colors = { Pending: "warning", Approved: "success", Rejected: "danger" };
                return (
                    <Badge bg={colors[row?.currentStage] || "secondary"}>
                        {row?.currentStage || "—"}
                    </Badge>
                );
            },
        },
        {
            name: "Items",
            center: true,
            selector: (row) => row?.suggestionItems?.length || 0,
        },
        {
            name: "Total Amount",
            center: true,
            selector: (row) => `₹ ${parseFloat(row?.totalAmount || 0).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Created At",
            center: true,
            sortable: true,
            selector: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
        },
        {
            name: "Action",
            center: true,
            selector: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip style={{ position: "fixed" }}>View Details</Tooltip>}
                >
                    <span
                        style={{ cursor: "pointer", color: "#0d6efd" }}
                        onClick={() => navigate(`/dashboard/suggestions/${row?.id || row?._id}`)}
                    >
                        <i className="far fa-eye table-icons"></i>
                    </span>
                </OverlayTrigger>
            ),
        },
    ];

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {userDetails.isLoading || tripDetails.isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "3rem" }}>
                            <Card>
                                <Card.Body>
                                    <span style={{ left: "99%" }} className={`position-absolute top-0 translate-middle badge rounded-pill ${!trip?.isStarted ? "bg-info" : (trip?.isCompleted ? (trip?.isNotEnded ? "bg-danger" : "bg-success") : (moment().startOf('day').valueOf() !== trip?.date ? "bg-danger" : "bg-warning"))}`}>
                                        {!trip?.isStarted ? "Scheduled" : (trip?.isCompleted ? (trip?.isNotEnded ? "Not Ended" : "Completed") : (moment().startOf('day').valueOf() !== trip?.date ? "Not Ended" : "On going"))}
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                    <div className='d-flex flex-column'>
                                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                                            <div className="d-flex flex-wrap align-items-center">
                                                <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                    {user?.profileURL !== "" ? <Image className="rounded-circle img-fluid avatar-100" src={user?.profileURL} alt="profile-img" /> : <>
                                                        <Image className="theme-color-default-img  img-fluid rounded-pill avatar-100" src={avatars11} alt="profile-pic" />
                                                        <Image className="theme-color-purple-img img-fluid rounded-pill avatar-100" src={avatars22} alt="profile-pic" />
                                                        <Image className="theme-color-blue-img img-fluid rounded-pill avatar-100" src={avatars33} alt="profile-pic" />
                                                        <Image className="theme-color-green-img img-fluid rounded-pill avatar-100" src={avatars55} alt="profile-pic" />
                                                        <Image className="theme-color-yellow-img img-fluid rounded-pill avatar-100" src={avatars66} alt="profile-pic" />
                                                        <Image className="theme-color-pink-img img-fluid rounded-pill avatar-100" src={avatars44} alt="profile-pic" />
                                                    </>}
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                        <h4 className="me-2 h4">{user?.name} <Badge bg={user?.userType === "employee" ? "info" : (user?.isAdmin ? "primary" : "success")}>{user?.userType === "employee" ? user?.userType : (user?.isAdmin ? "Super Admin" : "Manager")}</Badge></h4>
                                                    </div>
                                                    <span>{user?.designation}</span>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column justify-content-center'>
                                                <span>Date: {moment(trip?.date).format("DD/MM/YY")}</span>
                                                <span>{trip?.startTime ? moment(trip?.startTime).format("hh:mm A") : "-"} - {trip?.endTime ? moment(trip?.endTime).format("hh:mm A") : "-"}</span>
                                            </div>
                                        </div>
                                        <Row className="row-cols-1">
                                            <div className="d-slider1 ">
                                                <Swiper
                                                    className="p-0 m-0 mb-2 list-inline "
                                                    slidesPerView={5}
                                                    spaceBetween={32}
                                                    navigation={{
                                                        nextEl: ".swiper-button-next",
                                                        prevEl: ".swiper-button-prev",
                                                    }}
                                                    breakpoints={{
                                                        320: { slidesPerView: 1 },
                                                        550: { slidesPerView: 2 },
                                                        991: { slidesPerView: 3 },
                                                        1400: { slidesPerView: 3 },
                                                        1500: { slidesPerView: 4 },
                                                        1920: { slidesPerView: 4 },
                                                        2040: { slidesPerView: 7 },
                                                        2440: { slidesPerView: 8 }
                                                    }}

                                                >
                                                    <SwiperSlide className="card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.primary}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={90}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {trip?.totalDistance === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Total Distance</p>
                                                                    <h4 className="counter">
                                                                        {parseFloat(trip?.totalDistance / 1000).toFixed(2)} km
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className="card card-slide" >
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.info}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={45}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {trip?.manualDistance === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Manually Calculated</p>
                                                                    <h4 className="counter">
                                                                        {Math.max(parseFloat((trip?.manualDistance || 0.0) / 1000).toFixed(2), 0.00)} km
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className="card card-slide" >
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.primary}
                                                                    width="60px"
                                                                    height="60px"
                                                                    Linecap="rounded"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={75}
                                                                    id="circle-progress-01"
                                                                >
                                                                    {trip?.autoCalculatedDistance === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Auto Calculated</p>
                                                                    <h4 className="counter">
                                                                        {parseFloat((trip?.autoCalculatedDistance || 0.0)).toFixed(2)} km
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className=" card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.info}
                                                                    width="60px"
                                                                    height="60px"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    Linecap="rounded"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={70}
                                                                    id="circle-progress-03"
                                                                >
                                                                    <svg className="" width="24" viewBox="0 0 24 24">
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg>
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Total Expense</p>
                                                                    <h4 className="counter">
                                                                        ₹ {trip?.totalExpense > 1000 ? parseFloat(trip?.totalExpense / 1000).toFixed(2) + "K" : parseFloat(trip?.totalExpense).toFixed(2)}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide className=" card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.primary}
                                                                    width="60px"
                                                                    height="60px"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    Linecap="rounded"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={60}
                                                                    id="circle-progress-02"
                                                                >
                                                                    {trip?.totalNewFarmers === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Total Farmers</p>
                                                                    <h4 className="counter">
                                                                        {trip?.totalNewFarmers || 0}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide className=" card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.info}
                                                                    width="60px"
                                                                    height="60px"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    Linecap="rounded"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={60}
                                                                    id="circle-progress-05"
                                                                >
                                                                    {trip?.totalNewSuggestions === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Total Suggestions</p>
                                                                    <h4 className="counter">
                                                                        {trip?.totalNewSuggestions || 0}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide className=" card card-slide">
                                                        <div className="card-body">
                                                            <div className="progress-widget">
                                                                <Circularprogressbar
                                                                    stroke={variableColors.info}
                                                                    width="60px"
                                                                    height="60px"
                                                                    trailstroke="#ddd"
                                                                    strokewidth="4px"
                                                                    Linecap="rounded"
                                                                    style={{ width: 60, height: 60 }}
                                                                    value={60}
                                                                    id="circle-progress-04"
                                                                >
                                                                    {trip?.tasksCompleted === 0 ?
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                            />
                                                                        </svg> :
                                                                        <svg
                                                                            className=""
                                                                            width="24"
                                                                            height="24px"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                            />
                                                                        </svg>}
                                                                </Circularprogressbar>
                                                                <div className="progress-detail">
                                                                    <p className="mb-2">Tasks Completed</p>
                                                                    <h4 className="counter">
                                                                        {trip?.tasksCompleted} / {trip?.tasks?.length}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <div className="swiper-button swiper-button-next"></div>
                                                    <div className="swiper-button swiper-button-prev"></div>
                                                </Swiper>
                                            </div>
                                        </Row>

                                        <div className='d-flex w-100'>

                                            {(trip?.startKM !== 0 || trip?.startImage !== "" || trip?.endImage !== "" || trip?.endKM !== 0) && <Col sm="3">
                                                <Card className='d-flex flex-column'>
                                                    <Card.Body>
                                                        <Accordion>
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>Start & End Image</Accordion.Header>
                                                                <Accordion.Body className='d-flex' style={{ columnGap: "1rem" }}>
                                                                    {(trip?.startKM !== 0 || trip?.startImage !== "") && <div>
                                                                        Start Image
                                                                        <Zoom><img src={trip?.startImage} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ height: "100px", maxWidth: "100px", pointerEvents: "none" }} /></Zoom>

                                                                        Distance: <br />{parseFloat((trip?.startKM || 0.0)).toFixed(2)} km
                                                                    </div>}
                                                                    {(trip?.endKM !== 0 || trip?.endImage !== "") && <div>
                                                                        End Image
                                                                        <Zoom><img onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} src={trip?.endImage} style={{ height: "100px", maxWidth: "100px", pointerEvents: "none" }} /></Zoom>
                                                                        Distance: <br />{parseFloat((trip?.endKM || 0.0)).toFixed(2)} km
                                                                    </div>}
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    </Card.Body>
                                                </Card>
                                            </Col>}


                                            {(trip?.modeOfTransport !== "" || trip?.dailyAllowance !== "") && <Col sm="3">
                                                <Card className='d-flex flex-column'>
                                                    <Card.Body>
                                                        <Accordion>
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>Mode Of Transports & DA</Accordion.Header>
                                                                <Accordion.Body className='d-flex flex-column' style={{ columnGap: "1rem" }}>
                                                                    {trip?.modeOfTransport !== "" &&
                                                                        <span>
                                                                            <b>Mode of Transport:</b> {trip?.modeOfTransport}
                                                                        </span>
                                                                    }

                                                                    {trip?.dailyAllowance !== "" &&
                                                                        <span>
                                                                            <b>DA:</b> {trip?.dailyAllowance}
                                                                        </span>
                                                                    }
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    </Card.Body>
                                                </Card>
                                            </Col>}

                                            {(trip?.route && trip?.route !== "") && <Col sm="3">
                                                <Card className='d-flex flex-column'>
                                                    <Card.Body>
                                                        <Accordion>
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>Route</Accordion.Header>
                                                                <Accordion.Body className='d-flex flex-column' style={{ columnGap: "1rem" }}>
                                                                    <span>
                                                                        <b>Route:</b> {trip?.route}
                                                                    </span>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            }

                                            <div className='d-flex w-100 align-self-end justify-content-center my-auto mt-4 ms-3'>
                                                <Dropdown className="ms-auto">
                                                    <Dropdown.Toggle as={CustomToggle} variant="light" className="dropdown-toggle">
                                                        <i className="fas fa-cog"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {trip.isStarted && <Dropdown.Item onClick={() => setShowEditTripModal(true)}>Edit Trip</Dropdown.Item>}
                                                        {(trip?.isCompleted && !trip?.isNotEnded) && <Dropdown.Item onClick={handleMarkTripInvalid}>Mark Invalid</Dropdown.Item>}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                        </div>

                                        <div className='d-flex justify-content-center align-items-center'>
                                            <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="first">Tasks</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="third">Expenses</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="fifth">Farmers</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item as="li">
                                                    <Nav.Link eventKey="sixth">Suggestions</Nav.Link>
                                                </Nav.Item>
                                                {trip?.isCompleted && <Nav.Item as="li">
                                                    <Nav.Link eventKey="fourth">Map</Nav.Link>
                                                </Nav.Item>}
                                            </Nav>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg="12">
                            <Tab.Content className="profile-content">
                                <Tab.Pane eventKey="first" id="profile-feed">
                                    {(tripDetails.isLoading || tripDetails?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> :
                                        <Row>


                                            <Col sm={"12"}>
                                                <Card>
                                                    <Card.Body>
                                                        {!trip.isCompleted && <div className='d-flex justify-content-end w-100'>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}><i onClick={() => setShowEditTaskModal(true)} style={{ cursor: "pointer" }} class="fas fa-edit"></i></OverlayTrigger>
                                                        </div>}
                                                        {<DataTable
                                                            defaultSortAsc={false}
                                                            columns={taskColumns}
                                                            data={trip?.tasks}
                                                            pagination={true}
                                                            paginationPerPage={35} // Set default rows per page to 35
                                                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]} // Keep the options
                                                        />}
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                        </Row>
                                    }
                                </Tab.Pane>
                                {organisationSignal?.value?.isOrderModuleActivated && <Tab.Pane eventKey="second" id="profile-activity">
                                    {ordersDetails.isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> :
                                        <Row>
                                            <Col sm="12">
                                                <Card>
                                                    <Card.Body>
                                                        {<DataTable
                                                            customStyles={{
                                                                rows: {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        backgroundColor: "unset"
                                                                    }
                                                                }
                                                            }}
                                                            defaultSortAsc={false}
                                                            columns={ordersColumns}
                                                            data={orders}
                                                            pagination={true}
                                                            paginationPerPage={35} // Set default rows per page to 35
                                                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]} // Keep the options
                                                        />}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    }
                                </Tab.Pane >}
                                <Tab.Pane eventKey="third" id="profile-activity">
                                    {expensesDetails.isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> :
                                        <Row>
                                            <Col sm="12">
                                                <Card>
                                                    <Card.Body>
                                                        {<DataTable
                                                            customStyles={{
                                                                rows: {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        backgroundColor: "unset"
                                                                    }
                                                                }
                                                            }}
                                                            defaultSortAsc={false}
                                                            columns={expenseColumns}
                                                            data={expenses}
                                                            pagination={true}
                                                            paginationPerPage={35} // Set default rows per page to 35
                                                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]} // Keep the options
                                                            onRowClicked={(row) => {
                                                                setSelectedExpense(row);
                                                                setShowExpenseViewModal(true);
                                                            }}
                                                        />}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    }
                                </Tab.Pane >
                                {trip?.isCompleted && <Tab.Pane eventKey="fourth" id="profile-friends">
                                    <Row>
                                        <Col sm="12">
                                            <Card>
                                                <Card.Body>
                                                    <TripTimeline tripId={id} trip={trip} />
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Tab.Pane >}
                                <Tab.Pane eventKey="fifth" id="trip-farmers">
                                    {(tripDetails.isLoading || tripDetails?.isFetching) ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                            <div className="spinner-border text-primary m-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <Row>
                                            <Col sm="12">
                                                <Card>
                                                    <Card.Body>
                                                        <DataTable
                                                            customStyles={{
                                                                rows: {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        backgroundColor: "unset"
                                                                    }
                                                                }
                                                            }}
                                                            defaultSortAsc={false}
                                                            columns={farmerColumns}
                                                            data={trip?.farmers || []}
                                                            pagination={true}
                                                            paginationPerPage={35}
                                                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                                            onRowClicked={(row) => navigate(`/dashboard/farmers/${row?.id || row?._id}`)}
                                                            noDataComponent={<div className="p-3 text-muted">No farmers found for this trip.</div>}
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="sixth" id="trip-suggestions">
                                    {(tripDetails.isLoading || tripDetails?.isFetching) ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                            <div className="spinner-border text-primary m-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <Row>
                                            <Col sm="12">
                                                <Card>
                                                    <Card.Body>
                                                        <DataTable
                                                            customStyles={{
                                                                rows: {
                                                                    style: {
                                                                        cursor: "pointer",
                                                                        backgroundColor: "unset"
                                                                    }
                                                                }
                                                            }}
                                                            defaultSortAsc={false}
                                                            columns={suggestionColumns}
                                                            data={trip?.suggestions || []}
                                                            pagination={true}
                                                            paginationPerPage={35}
                                                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                                            onRowClicked={(row) => navigate(`/dashboard/suggestions/${row?.id || row?._id}`)}
                                                            noDataComponent={<div className="p-3 text-muted">No suggestions found for this trip.</div>}
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    )}
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }
            {showExpenseViewModal && <ExpenseViewModal updateExpenseStatus={updateExpenseStatus} expense={selectedExpense} show={showExpenseViewModal} close={() => setShowExpenseViewModal(false)} />}

            {showEditTaskModal && <EditTaskModal show={showEditTaskModal} trip={trip} close={() => setShowEditTaskModal(false)} refetchTrip={() => tripDetails.refetch({ cancelRefetch: true })} />}

            {showEditTripModal && <EditTripModal show={showEditTripModal} trip={trip} close={() => setShowEditTripModal(false)} refetchTrip={() => tripDetails.refetch({ cancelRefetch: true })} />}

        </Fragment>
    )

}

export default TripDetails;